<template>
    <div>
        <div class="row mb-3">
            <div class="col-md-4">
                <page-header :title="$t('pages.locker.my_aform.notes')" :use-title-as-document-title="false"></page-header>

                <notes></notes>
            </div>
            <div class="col-md-8">
                <page-header :title="$t('pages.locker.my_aform.my_favorite_trainings')" :use-title-as-document-title="false"></page-header>

                <div class="row" v-if="videos.length">
                    <div class="col-md-6 grid-margin" v-for="video in videos" :key="video.id">
                        <gym-video-card-new :video="video" :page-link-enabled="true"/>
                    </div>
                </div>
                <div class="alert alert-secondary border-dark shadow-sm" v-else>
                    {{ $t('pages.locker.my_aform.no_favorites') }}
                </div>

                <div class="mt-3">
                    <pagination :data="paginationData" @pagination-change-page="getVideos"></pagination>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <page-header :title="$t('pages.locker.my_aform.training_stats')" :use-title-as-document-title="false"></page-header>
                <div class="row mb-5">
                    <div class="col-md-12">
                        <stats-infos :user="null" :dates="datesForStatsInfos"></stats-infos>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <stats-calendar :user="null" @date-change="calendarDateChanged"></stats-calendar>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GymVideoCardNew from "../../Gym/Includes/GymVideoCardNew";
import PageHeader from "../../Includes/PageHeader";
import GymRepository from "../../../repositories/Gym/GymRepository";
import StatsCalendar from "./Includes/StatsCalendar";
import StatsInfos from "./Includes/StatsInfos";
import Notes from "./Includes/Notes";

export default {
    name: "MyAform",
    components: {Notes, StatsInfos, StatsCalendar, PageHeader, GymVideoCardNew},
    data: () => ({
        videos: [],
        paginationData: {},
        userStats: [],

        datesForStatsInfos: null,
    }),
    mounted() {
        this.getVideos();
    },
    methods: {
        calendarDateChanged(dates) {
            this.datesForStatsInfos = dates;
        },
        getVideos(page = 1) {
            this.filterActive = false;
            GymRepository
                .getVideos(page, 'favorites')
                .then((res) => {
                    this.videos = res.data.data;

                    this.totalVideosFound = res.data.total;
                    this.paginationData = res.data.meta;
                });
        },
    }
}
</script>

<style scoped>

</style>
